import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ExamManagementService } from '../../../../../../Services/exam-management/exam-management.service';
import { ActivatedRoute } from '@angular/router';
import { SessionService } from '../../../../../../Services/session.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  ExamInstance,
  ExamMaster,
  IExamInstance,
} from '../../../../../../Models/ExamAgencies';
import { ConstantVars } from 'src/app/utils/constants/constants';
import { ToastrService } from 'ngx-toastr';
import { ModalService } from 'src/app/Services/confirmation-modal/modalServie.service';
import { environment } from 'src/environments/environment';
export interface ISubjectList {
  Course_Subject_Id: any
  Course_Id: any
  Subject_ID: number
  Subject_Name: string
  Subject_Selected_Ind: string
}

type RowVM = IExamInstance & { _cid: string; _isNew?: boolean };
@Component({
  selector: 'app-exam-instance-subjects-ca',
  templateUrl: './exam-instance-subjects.component.html',
  styleUrls: ['./exam-instance-subjects.component.css'],
})
export class ExamInstanceSubjectsCAComponent implements OnInit {
  @Output() CloseExaminstancesubject: EventEmitter<any> =
    new EventEmitter<any>();
  cmName: string;
  cName: string;
  formSubmitted = false;
  subjectList: ISubjectList[]= [];
  public env = environment;
  @Input() examYear: string;
  @Input() set courseMasterName(value: any) {
    if (!value) return;

    this.courseMasterNameControl.setValue(value);
  }
  @Input() set courseName(value: any) {
    if (!value) return;

    this.courseNameControl.setValue(value);
    this.courseNameControl.disable();
  }
  @Input() courseId: string | undefined;
  @Input() courseMasterId: string;
  @Input() examAgencyId:string;
  @Output() onCloseSubject: EventEmitter<any> = new EventEmitter<any>();
  firstCourseId: any;
  response: any;
  response1: any;
  InsertInstance: ExamInstance;
  drafts :any[]

  ExamInstanceSubject: RowVM[] = [];
  toDeleteRows: RowVM[] = [];
  private _cid = 0;
  private nextCid() { return `r-${++this._cid}`; }

  courseMasterNameControl: FormControl = new FormControl();
  courseNameControl: FormControl = new FormControl();
  Exam_Year: FormControl = new FormControl('');
  ExamInstanceSubjectForm = new FormGroup({
    Exam_Agency_Name: new FormControl(''),
    Exam_Short_Name: new FormControl(''),
    Exam_Name: new FormControl(''),
    Exam_Level_Type_Code: new FormControl(''),
    Exam_Difficulty_Level_Type_Code: new FormControl(''),
    Exam_Duration: new FormControl(''),
    Number_Of_Question: new FormControl(''),
    Total_Test_Score: new FormControl(''),
    Right_Answer_Default_Score: new FormControl(''),
    Wrong_Answer_Penalty_Default_Score: new FormControl(''),
    Exam_Description: new FormControl(''),
    Exam_Instance_Name: new FormControl(''),
    Notification_Date: new FormControl(''),
    Notification_Url: new FormControl(''),
    Application_Due_Date: new FormControl(''),
    Scheduled_Exam_Date: new FormControl(''),
    Exam_Instance_Description: new FormControl(''),
    Preview_Exam_Instance_Name: new FormControl(''),
    Exam_Master_ID: new FormControl(''),
    Exam_Instance_ID: new FormControl(''),
  });
  constructor(
    public toastr: ToastrService,
    public ExamService: ExamManagementService,
    public session: SessionService,
    private modService: ModalService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.getDifficultLevelType();
    this.getSubjectListForDropDown()

    this.ExamService.getExamInstanceSubject({
      LoggedInUserID: this.session.getUser(),
      CourseID: +this.courseId!,
      CourseSubjectID: null,
    }).subscribe(
      (res) => {
        this.getExamInstanceSubjectResponse(res);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  ngAfterViewInit() {
    this.firstCourseId = this.courseId;
    this.getExamInstanceName();
    this.Exam_Year.setValue(this.examYear);
    this.Exam_Year.disable();
    document.querySelector('#viewCourse')?.scrollIntoView();
  }

  Touched: boolean = false;

  MinimumExpectedWeightage(event: any, index: any) {
    this.Touched = true;
    // this.ExamInstanceSubject[index].Minimum_Expected_Weightage=event;
    if (this.ExamInstanceSubject[index].Maximum_Expected_Weightage) {
      if (
        Number(event) >
        Number(this.ExamInstanceSubject[index].Maximum_Expected_Weightage)
      ) {
        this.toastr.warning('The Minimum cannot be higher  to the Maximum');
        this.ExamInstanceSubject[index].MinimumError = true;
        this.ExamInstanceSubject[index].MaximumError = false;
      } else {
        this.ExamInstanceSubject[index].Minimum_Expected_Weightage = event;
        this.ExamInstanceSubject[index].MinimumError = false;
        this.ExamInstanceSubject[index].MaximumError = false;
      }
    } else {
      this.ExamInstanceSubject[index].Minimum_Expected_Weightage = event;
      this.ExamInstanceSubject[index].MinimumError = false;
      this.ExamInstanceSubject[index].MaximumError = false;
    }
  }
  MultiPartQuestionPercentage(event: any, index: any) {
    this.Touched = true;
    this.ExamInstanceSubject[index].Multi_Part_Question_Percentage = event;
  }
  MaximumExpectedWeightage(event: any, index: any) {
    this.Touched = true;
    // this.ExamInstanceSubject[index].Maximum_Expected_Weightage=event;
    if (this.ExamInstanceSubject[index].Minimum_Expected_Weightage) {

if (Number(event) < Number((this.ExamInstanceSubject?.[index]?.Minimum_Expected_Weightage ?? 0))) {
        this.toastr.warning('The Maximum cannot be lesser to the Minimum');
        this.ExamInstanceSubject[index].MaximumError = true;
        this.ExamInstanceSubject[index].MinimumError = false;
      } else {
        this.ExamInstanceSubject[index].Maximum_Expected_Weightage = event;
        this.ExamInstanceSubject[index].MaximumError = false;
        this.ExamInstanceSubject[index].MinimumError = false;
      }
    } else {
      this.ExamInstanceSubject[index].Maximum_Expected_Weightage = event;
      this.ExamInstanceSubject[index].MaximumError = false;
      this.ExamInstanceSubject[index].MinimumError = false;
    }
  }
  LowerDifficultyLevelTypeCode(event: any, index: any) {
    this.Touched = true;
    // this.ExamInstanceSubject[index].Lower_Difficulty_Level_Type_Code=event;

    if (
      this.ExamInstanceSubject[index].Upper_Difficulty_Level_Type_Code != ''
    ) {
      if (
        Number(event) >
        Number(this.ExamInstanceSubject[index].Upper_Difficulty_Level_Type_Code)
      ) {
        this.toastr.warning('The Lower range cannot be higher the Upper range');
        this.ExamInstanceSubject[index].LowerError = true;
        this.ExamInstanceSubject[index].UpperError = false;
      } else {
        this.ExamInstanceSubject[index].Lower_Difficulty_Level_Type_Code =
          event;
        this.ExamInstanceSubject[index].LowerError = false;
        this.ExamInstanceSubject[index].UpperError = false;
      }
    } else {
      this.ExamInstanceSubject[index].Lower_Difficulty_Level_Type_Code = event;
      this.ExamInstanceSubject[index].LowerError = false;
      this.ExamInstanceSubject[index].UpperError = false;
    }
  }
  UpperDifficultyLevelTypeCode(event: any, index: any) {
    this.Touched = true;
    // this.ExamInstanceSubject[index].Upper_Difficulty_Level_Type_Code=event;
    if (
      this.ExamInstanceSubject[index].Lower_Difficulty_Level_Type_Code != ''
    ) {
      if (
        Number(event) <
        Number(this.ExamInstanceSubject[index].Lower_Difficulty_Level_Type_Code)
      ) {
        this.toastr.warning(
          'The Upper range cannot be Lesser to the Lower range'
        );
        this.ExamInstanceSubject[index].UpperError = true;
        this.ExamInstanceSubject[index].LowerError = false;
      } else {
        this.ExamInstanceSubject[index].Upper_Difficulty_Level_Type_Code =
          event;
        this.ExamInstanceSubject[index].UpperError = false;
        this.ExamInstanceSubject[index].LowerError = false;
      }
    } else {
      this.ExamInstanceSubject[index].Upper_Difficulty_Level_Type_Code = event;
      this.ExamInstanceSubject[index].UpperError = false;
      this.ExamInstanceSubject[index].LowerError = false;
    }
  }

  getexaminstancename: any;
  getExamInstanceName() {
    this.ExamService.GetCodeCourse({
      // COURSE MASTER ID
      Tablename: 'COURSE@' + this.courseMasterId,
    }).subscribe(
      (i: any) => {
        this.getexaminstancename = i;
        // }).catch((e:any)=>{
        //   this.getcodes=null;
        // });
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
  // Current Work
  async onClose(){

    if(JSON.stringify(this.InitialExamInstanceSubject) !== JSON.stringify(this.ExamInstanceSubject)){

    const confirmed = await this.modService.open(
    'Confirmation',
    `You have some unchanged changes, Do you want to save before leaving`
    );

  if (confirmed){
    this.Save(false,true)

  }else{
    this.onCloseSubject.emit()
  }
  }else{
    this.onCloseSubject.emit()
  }
  }

  addvalue() {
    this.formSubmitted = false;
    const row: RowVM = {
      Course_ID: Number(this.courseId ?? 0),
      Course_Subject_ID: null,
      Subject_Id: null,
      Subject_Name: null,

      Minimum_Expected_Weightage: null,
      Maximum_Expected_Weightage: null,
      Lower_Difficulty_Level_Type_Code: '',
      Lower_Difficulty_Level_Type_Name: '',
      Upper_Difficulty_Level_Type_Code: '',
      Upper_Difficulty_Level_Type_Name: '',

      Include_Questions_With_Images_Ind: 'N',
      Multi_Part_Question_Percentage: null,
      Multiple_Choice_Question_Count: null,

      Number_Of_Major_Topics: null,
      Number_Of_Concepts: null,
      Deleted_Ind: 'N',
      Display_Order:null,
      MinimumError: false,
      MaximumError: false,
      UpperError: false,
      LowerError: false,
      ImagePreview:null,
      ImageFile:null,
      Course_Subject_Image_File_Object_Id:   null,
      Course_Subject_Image_File_Name:  null,
      Course_Subject_Image_File_Name_In_Server:  null,
      Course_Subject_Image_File_Source_Modified_Datetime: null, // or Date
      Course_Subject_Image_File_Type_Code: null,
      Course_Subject_Image_File_Location_Name: null,
      Course_Subject_Image_Height:  null,
      Course_Subject_Image_Width:  null,

      Course_Subject_Image_Deleted_Ind: 'N',
      Course_Subject_Image_Archive_Ind:  null,
      Course_Subject_Image_File_Archive_Location_Name: null,
      Course_Subject_Image_Error_Message:  null,
      Course_Subject_Image_Success_Ind:  null,

      _cid: this.nextCid(),
      _isNew: true
    };

    this.ExamInstanceSubject = [...this.ExamInstanceSubject, row];
  }

  onImageSelected(event: Event, subject: any, index: number): void {
  const input = event.target as HTMLInputElement;
  if (!input.files || input.files.length === 0) { return; }

  const file = input.files[0];

  // Optional: file size limit (example: 5MB)
  // const maxSizeBytes = 5 * 1024 * 1024;
  // if (file.size > maxSizeBytes) {
  //   alert('Image is too large. Maximum allowed size is 5 MB.');
  //   input.value = ''; // reset input
  //   return;
  // }

  if (!file.type.startsWith('image/')) {
    alert('Please select a valid image file.');
    input.value = '';
    return;
  }

  // keep file reference (for later upload)
  subject.ImageFile = file;

  // create preview
  const reader = new FileReader();
  reader.onload = (e: ProgressEvent<FileReader>) => {
    subject.ImagePreview = e.target?.result as string;
  };
  reader.readAsDataURL(file);

  // OPTIONAL: if you want to upload immediately for persisted rows
  // if (this.isRowPersisted(subject)) {
  //   this.uploadImageToServer(subject, index);
  // }
}

removeImage(subject: IExamInstance, index: number): void {
  // Remove client-side preview and file pointer
  subject.ImagePreview = null;
  subject.ImageFile = null;

  // If image was previously uploaded to server, delete it on server as well
  if (subject.Course_Subject_Image_File_Object_Id) {
    subject.Course_Subject_Image_Deleted_Ind ='Y'
  }
  console.log(subject);

}

checkStatus(s: any): boolean {
  const hasFileObject = !!s.Course_Subject_Image_File_Object_Id;
  const isDeleted     = s.Course_Subject_Image_Deleted_Ind === 'Y';
  const hasImageFile  = !!s.ImageFile;

  const result = (hasFileObject && isDeleted && !s.ImageFile) || (!hasFileObject && !hasImageFile);
  return result;
}






async deleteSubject(index: number) {
  const row = this.ExamInstanceSubject?.[index];
  if (!row) return;

  // ask for confirmation via your modal service
  const confirmed = await this.modService.open(
    'Delete subject?',
    `Are you sure you want to remove "${row.Subject_Name ?? 'this subject'}"? This is an irreversible action`
  );

  if (!confirmed) return;
    // keep your persisted-row tracking
  if (row.Course_Subject_ID != null) {
    this.toDeleteRows.push({ ...row, Deleted_Ind: 'Y' });
  }

  // immutable remove
  this.ExamInstanceSubject = this.ExamInstanceSubject.filter((_, i) => i !== index);

  if (row.Course_Subject_ID != null) {
  this.Save(true)
  }


}


  getSubjectListForDropDown(){
    const paylaod =  {
    LoggedInUserID: this.session.getUser(),
    ExamInstanceID: this.courseId
  }
    this.ExamService.getExamSubjectList(paylaod).subscribe({
      next:(res:any)=>{
        this.subjectList = res.Data;

      },
      error:(error)=>{
        console.log(error);

      }
    })
  }

// helper: is a subject used in any other (active) row?
 isSubjectUsed(subjectId: number | null, currentRow: any): boolean {
  if (subjectId == null) return false;
  return this.ExamInstanceSubject?.some(
    (r: any) => r !== currentRow && r.Deleted_Ind === 'N' && r.Subject_Id === subjectId
  ) ?? false;
}




onSubjectChange(newId: number | null, row: any) {
  row.subjectDupError = false;

  if (newId == null) {
    row.Subject_Name = null;
    row._prevSubjectId = null;
    return;
  }

  const duplicate = this.isSubjectUsed(newId, row);

  if (duplicate) {
    // ✅ show toaster only for *new* rows
    if (row._isNew) {
      this.toastr.error('Subject already selected', 'Duplicate');
    }

    // revert selection (new rows likely revert to null)
    row.Subject_Id = row._prevSubjectId ?? null;
    row.Subject_Name = row.Subject_Id
      ? (this.subjectList.find((o: any) => o.Subject_ID === row.Subject_Id)?.Subject_Name ?? null)
      : null;

    row.subjectDupError = true;
    return;
  }

  // valid selection → sync + mark row as no longer "new"
  const opt = this.subjectList?.find((o: any) => o.Subject_ID === newId);
  row.Subject_Name = opt?.Subject_Name ?? null;
  row._prevSubjectId = newId;
  row._isNew = false; // ✅ first valid selection completes the row
}


isSubjectLocked(row: any): boolean {
  if (!row?.Subject_Id) return false;
  const opt = this.subjectList?.find(o => o.Subject_ID === row.Subject_Id);
  if (!opt) return false;


  const usedByAnotherRow =
    Array.isArray(this.ExamInstanceSubject) &&
    this.ExamInstanceSubject.some(r =>  r.Subject_Id === row.Subject_Id);

  return opt.Subject_Selected_Ind === 'Y' && usedByAnotherRow;
}





InitialExamInstanceSubject: IExamInstance[]
getExamInstanceSubjectResponse(res: any) {
  if(res.status){

  const rows = (res?.data ?? []) as IExamInstance[];

  // Build fresh RowVMs from server data (single pass)
  this.ExamInstanceSubject = rows.map((r) => ({
    ...r,
    Deleted_Ind: r.Deleted_Ind ?? 'N',
    Display_Order: r.Display_Order,
    MinimumError: false,
    MaximumError: false,
    UpperError: false,
    LowerError: false,
    ImagePreview:null,
    ImageFile:null,
    Course_Subject_Image_File_Object_Id:  r.Course_Subject_Image_File_Object_Id || null,
    Course_Subject_Image_File_Name:  r.Course_Subject_Image_File_Name || null,
    Course_Subject_Image_File_Name_In_Server:  r.Course_Subject_Image_File_Name_In_Server || null,
    Course_Subject_Image_File_Source_Modified_Datetime:  r.Course_Subject_Image_File_Source_Modified_Datetime || null, // or Date
    Course_Subject_Image_File_Type_Code:  r.Course_Subject_Image_File_Type_Code || null,
    Course_Subject_Image_File_Location_Name:  r.Course_Subject_Image_File_Location_Name || null,
    Course_Subject_Image_Height:  r.Course_Subject_Image_Height || null,
    Course_Subject_Image_Width:  r.Course_Subject_Image_Width,

    Course_Subject_Image_Deleted_Ind:  r.Course_Subject_Image_Deleted_Ind  || 'N',
    Course_Subject_Image_Archive_Ind:  r.Course_Subject_Image_Archive_Ind ||null,
    Course_Subject_Image_File_Archive_Location_Name: r.Course_Subject_Image_File_Archive_Location_Name || null,
    Course_Subject_Image_Error_Message:  null,
    Course_Subject_Image_Success_Ind:  null,
    _cid: this.nextCid(),
    _isNew: false
    })) as RowVM[];

 this.InitialExamInstanceSubject = JSON.parse(JSON.stringify(this.ExamInstanceSubject));


  // Fresh load => clear any queued deletes
  this.toDeleteRows = [];

  // Enable/disable preview control based on presence of rows
  const ctrl = this.ExamInstanceSubjectForm.get('Preview_Exam_Instance_Name');
  if (this.ExamInstanceSubject.length > 0) {
    ctrl?.disable();
  } else {
    ctrl?.enable();
  }
}
}


  ExamAgency: any;
  response3: any;
  ExamAgencydataSource: any;
  getExamAgenciesResponse(data: any) {
    this.response3 = data;
    this.ExamAgency = this.response3.Data;
    this.ExamAgencydataSource = this.ExamAgency;
    if (this.ExamAgencydataSource != null) {
      this.ExamInstanceSubjectForm.controls['Exam_Agency_Name'].setValue(
        this.ExamAgencydataSource[0].Exam_Agency_Name
      );
    }
  }

  ExamMaster: any;
  ExamMasterdataSource: any;
  getExamMasterResponse(data: any) {
    this.response = data;
    this.ExamMaster = this.response.Data;
    this.ExamMasterdataSource = this.ExamMaster;
    if (this.ExamMasterdataSource != null) {
      this.ExamInstanceSubjectForm.controls['Exam_Short_Name'].setValue(
        this.ExamMasterdataSource[0].Exam_Short_Name
      );
      this.ExamInstanceSubjectForm.controls['Exam_Name'].setValue(
        this.ExamMasterdataSource[0].Exam_Name
      );
      this.ExamInstanceSubjectForm.controls['Exam_Master_ID'].setValue(
        this.ExamMasterdataSource[0].Exam_Master_ID
      );
      this.ExamInstanceSubjectForm.controls['Exam_Level_Type_Code'].setValue(
        this.ExamMasterdataSource[0].Exam_Level_Type_Code
      );
      this.ExamInstanceSubjectForm.controls[
        'Exam_Difficulty_Level_Type_Code'
      ].setValue(this.ExamMasterdataSource[0].Exam_Difficulty_Level_Type_Code);
      this.ExamInstanceSubjectForm.controls['Exam_Duration'].setValue(
        this.ExamMasterdataSource[0].Exam_Duration
      );
      this.ExamInstanceSubjectForm.controls['Number_Of_Question'].setValue(
        this.ExamMasterdataSource[0].Number_Of_Question
      );
      this.ExamInstanceSubjectForm.controls['Total_Test_Score'].setValue(
        this.ExamMasterdataSource[0].Total_Test_Score
      );
      this.ExamInstanceSubjectForm.controls[
        'Right_Answer_Default_Score'
      ].setValue(this.ExamMasterdataSource[0].Right_Answer_Default_Score);
      this.ExamInstanceSubjectForm.controls[
        'Wrong_Answer_Penalty_Default_Score'
      ].setValue(
        this.ExamMasterdataSource[0].Wrong_Answer_Penalty_Default_Score
      );
      this.ExamInstanceSubjectForm.controls['Exam_Description'].setValue(
        this.ExamMasterdataSource[0].Exam_Description
      );
    }
  }

  ExamInstance: any;
  ExamInstancedataSource: any;
  getExamInstanceResponse(data: any) {
    this.response1 = data;
    this.ExamInstance = this.response1.Data;
    this.ExamInstancedataSource = this.ExamInstance;
    if (this.ExamService.ExamInstanceID != null) {
      if (this.ExamInstancedataSource != null) {
        this.ExamInstanceSubjectForm.controls['Exam_Instance_Name'].setValue(
          this.ExamInstancedataSource[0].Exam_Instance_Name
        );
        this.ExamInstanceSubjectForm.controls['Exam_Instance_ID'].setValue(
          this.ExamInstancedataSource[0].Exam_Instance_ID
        );
        this.ExamInstanceSubjectForm.controls['Notification_Date'].setValue(
          this.ExamInstancedataSource[0].Notification_Date
        );
        this.ExamInstanceSubjectForm.controls['Notification_Url'].setValue(
          this.ExamInstancedataSource[0].Notification_Url
        );
        this.ExamInstanceSubjectForm.controls['Application_Due_Date'].setValue(
          this.ExamInstancedataSource[0].Application_Due_Date
        );
        this.ExamInstanceSubjectForm.controls['Scheduled_Exam_Date'].setValue(
          this.ExamInstancedataSource[0].Scheduled_Exam_Date
        );
        this.ExamInstanceSubjectForm.controls[
          'Exam_Instance_Description'
        ].setValue(this.ExamInstancedataSource[0].Exam_Instance_Description);
      }
    }
  }
  examsubjectlistflag: boolean = false;
  Examinstancesubjectlist() {
    this.examsubjectlistflag = !this.examsubjectlistflag;
    if (this.examsubjectlistflag) {
      this.refreshSubject();
    }
  }
  refreshSubject() {
    this.ExamService.getExamInstanceSubject({
      LoggedInUserID: this.session.getUser(),
      CourseID: +this.courseId!,
      CourseSubjectID: null,
    }).subscribe(
      (res) => {
        this.getExamInstanceSubjectResponse(res);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  Close(data: any) {
    this.Examinstancesubjectlist();
  }
  getdifficultleveltype: any;
  getDifficultLevelType() {
    this.ExamService.GetCode({ Tablename: 'DIFFICULTY_LEVEL_TYPE' }).subscribe(
      (i: any) => {
        this.getdifficultleveltype = i;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  counter(i: number) {
    return new Array(i);
  }
  Filterlist: any;

  check: boolean;
  insertresponse: any;
  validationissue: boolean;
  private isEmpty(v: any): boolean {
  return v === null || v === undefined || v === '' || (typeof v === 'number' && isNaN(v));
}

isRowPersisted(row: RowVM): boolean {
  return row?.Course_Subject_ID != null; // persisted on server
}
  getOptionsForRow(row: RowVM): ISubjectList[] {
  const used = new Set(
    this.ExamInstanceSubject
      .filter(r => r._cid !== row._cid && r.Subject_Id != null)
      .map(r => r.Subject_Id as number)
  );

  const freed = new Set(
    this.toDeleteRows
      .filter(r => r.Subject_Id != null)
      .map(r => r.Subject_Id as number)
  );

  // show: subjects not used, OR used but being deleted, OR the row's current selection
  return this.subjectList.filter(opt =>
    !used.has(opt.Subject_ID) ||
    freed.has(opt.Subject_ID) ||
    opt.Subject_ID === row.Subject_Id
  );
}


Save(isDelete = false,isClose=false) {
  if(!isDelete){
  this.formSubmitted = true;
  }
  if (!this.ExamInstanceSubject?.length && !this.toDeleteRows?.length) return;

  // Validate only active rows
  this.validationissue = this.ExamInstanceSubject.some(item =>
    item.MaximumError || item.MinimumError || item.LowerError || item.UpperError
  );
  if (this.validationissue) {
    this.toastr.error('Validation Error');
    return;
  }
const missingImage = this.ExamInstanceSubject
  .filter(item => item.Deleted_Ind !== 'Y') // only active rows
  .some(item =>
    !item.ImagePreview &&
    (!item.Course_Subject_Image_File_Name_In_Server || item.Course_Subject_Image_Deleted_Ind === 'Y')
  );

if (missingImage && !isDelete) {
  this.toastr.error('Please add an image for every subject before saving.', '', {
    timeOut: ConstantVars.ToastErrorTimeout,
  });
  return;
}

  // Active rows (create/update)
  const activePayload = this.ExamInstanceSubject.map((e: IExamInstance) => ({
    Course_Id: this.firstCourseId,
    Subject_Id: e.Subject_Id, // should be non-null for actives
    Course_Subject_Id: !this.ExamInstanceSubjectForm.get('Preview_Exam_Instance_Name')?.value
      ? e.Course_Subject_ID
      : null, // if your backend forbids null here too, set to 0 instead
    Multiple_Choice_Question_Count: e.Multiple_Choice_Question_Count ?? 0,
    Minimum_Expected_Weightage: e.Minimum_Expected_Weightage ?? 0,
    Maximum_Expected_Weightage: e.Maximum_Expected_Weightage ?? 0,
    Lower_Difficulty_Level_Type_Code: e.Lower_Difficulty_Level_Type_Code || '',
    Upper_Difficulty_Level_Type_Code: e.Upper_Difficulty_Level_Type_Code || '',
    Include_Questions_With_Images_Ind: e.Include_Questions_With_Images_Ind || 'N',
    Multi_Part_Question_Percentage: e.Multi_Part_Question_Percentage ?? 0,
    Deleted_Ind: 'N',
    Display_Order: e.Display_Order ?? 0,

        // image metadata (if present on the client model)
    imageFile:(e as any).ImageFile ?? null,
    Course_Subject_Image_File_Object_Id: (e as any).Course_Subject_Image_File_Object_Id ?? null,
    Course_Subject_Image_File_Name: (e as any).Course_Subject_Image_File_Name ?? null,
    Course_Subject_Image_File_Name_In_Server: (e as any).Course_Subject_Image_File_Name_In_Server ?? null,
    Course_Subject_Image_File_Source_Modified_Datetime: (e as any).Course_Subject_Image_File_Source_Modified_Datetime ?? null,
    Course_Subject_Image_File_Type_Code: (e as any).Course_Subject_Image_File_Type_Code ?? null,
    Course_Subject_Image_File_Location_Name: (e as any).Course_Subject_Image_File_Location_Name ?? null,
    Course_Subject_Image_Height: (e as any).Course_Subject_Image_Height ?? null,
    Course_Subject_Image_Width: (e as any).Course_Subject_Image_Width ?? null,
    Course_Subject_Image_Deleted_Ind: (e as any).Course_Subject_Image_Deleted_Ind ?? null,
    Course_Subject_Image_Archive_Ind: (e as any).Course_Subject_Image_Archive_Ind ?? null,
    Course_Subject_Image_File_Archive_Location_Name: (e as any).Course_Subject_Image_File_Archive_Location_Name ?? null,
    Course_Subject_Image_Error_Message: (e as any).Course_Subject_Image_Error_Message ?? null,
    Course_Subject_Image_Success_Ind: (e as any).Course_Subject_Image_Success_Ind ?? null,
  }));

  // Delete rows (stashed), with NO nulls
const deletePayload = this.toDeleteRows.map((r) => ({
  Course_Id: this.firstCourseId,
  Subject_Id: r.Subject_Id ?? 0,
  Course_Subject_Id: r.Course_Subject_ID!, // persisted row
  Multiple_Choice_Question_Count: r.Multiple_Choice_Question_Count ?? 0,
  Minimum_Expected_Weightage: r.Minimum_Expected_Weightage ?? 0,
  Maximum_Expected_Weightage: r.Maximum_Expected_Weightage ?? 0,
  Lower_Difficulty_Level_Type_Code: r.Lower_Difficulty_Level_Type_Code || '',
  Upper_Difficulty_Level_Type_Code: r.Upper_Difficulty_Level_Type_Code || '',
  Include_Questions_With_Images_Ind: r.Include_Questions_With_Images_Ind || 'N',
  Multi_Part_Question_Percentage: r.Multi_Part_Question_Percentage ?? 0,
  Deleted_Ind: 'Y',
  Display_Order: r.Display_Order ?? 0,

  imageFile:(r as any).ImageFile ?? null,
  Course_Subject_Image_File_Object_Id: (r as any).Course_Subject_Image_File_Object_Id ?? null,
  Course_Subject_Image_File_Name: (r as any).Course_Subject_Image_File_Name ?? null,
  Course_Subject_Image_File_Name_In_Server: (r as any).Course_Subject_Image_File_Name_In_Server ?? null,
  Course_Subject_Image_File_Source_Modified_Datetime: (r as any).Course_Subject_Image_File_Source_Modified_Datetime ?? null,
  Course_Subject_Image_File_Type_Code: (r as any).Course_Subject_Image_File_Type_Code ?? null,
  Course_Subject_Image_File_Location_Name: (r as any).Course_Subject_Image_File_Location_Name ?? null,
  Course_Subject_Image_Height: (r as any).Course_Subject_Image_Height ?? null,
  Course_Subject_Image_Width: (r as any).Course_Subject_Image_Width ?? null,
  Course_Subject_Image_Deleted_Ind: (r as any).Course_Subject_Image_Deleted_Ind ?? null,
  Course_Subject_Image_Archive_Ind: (r as any).Course_Subject_Image_Archive_Ind ?? null,
  Course_Subject_Image_File_Archive_Location_Name: (r as any).Course_Subject_Image_File_Archive_Location_Name ?? null,
  Course_Subject_Image_Error_Message: (r as any).Course_Subject_Image_Error_Message ?? null,
  Course_Subject_Image_Success_Ind: (r as any).Course_Subject_Image_Success_Ind ?? null,
}));

  // Merge
  const UDTCourseSubject = [...activePayload, ...deletePayload];

  // Completeness check (actives only)
  const hasMissing = activePayload.some(item =>
    this.isEmpty(item.Minimum_Expected_Weightage) ||
    this.isEmpty(item.Maximum_Expected_Weightage) ||
    this.isEmpty(item.Lower_Difficulty_Level_Type_Code) ||
    this.isEmpty(item.Upper_Difficulty_Level_Type_Code) ||
    this.isEmpty(item.Multi_Part_Question_Percentage)
  );
  if (hasMissing && !isDelete) {
    this.toastr.error('Please choose all value','', {
            timeOut: ConstantVars.ToastErrorTimeout,
          });
    return;
  }

  const tempList = {
    LoggedInUser: this.session.getUser(),
    ErrorMessage: '',
    UDTCourseSubject:isDelete ? UDTCourseSubject.filter((e) => e.Course_Subject_Id !==null): UDTCourseSubject
  };

  const fd = new FormData();

  fd.append('LoggedInUser', this.session.getUser());
  fd.append('ErrorMessage', '');
  fd.append('courseSubjectsLength', String(tempList.UDTCourseSubject.length));
  fd.append('examAgencyId', String(this.examAgencyId));
  tempList.UDTCourseSubject.forEach((item, i) => {
    if(item?.imageFile){
    fd.append(`${item.Subject_Id}`,item.imageFile)
    }
  });
  tempList.UDTCourseSubject.forEach((item, i) => {
    const prefix = `courseSubject[${i}]`;

    const append = (name: string, value: any) => {
      const v = value === null || value === undefined ? '' : String(value);
      fd.append(`${prefix}.${name}`, v);
    };

    append('Course_Id', item.Course_Id);
    append('Subject_Id', item.Subject_Id);
    append('Course_Subject_Id', item.Course_Subject_Id);
    append('Multiple_Choice_Question_Count', item.Multiple_Choice_Question_Count);
    append('Minimum_Expected_Weightage', item.Minimum_Expected_Weightage);
    append('Maximum_Expected_Weightage', item.Maximum_Expected_Weightage);
    append('Lower_Difficulty_Level_Type_Code', item.Lower_Difficulty_Level_Type_Code);
    append('Upper_Difficulty_Level_Type_Code', item.Upper_Difficulty_Level_Type_Code);
    append('Include_Questions_With_Images_Ind', item.Include_Questions_With_Images_Ind);
    append('Multi_Part_Question_Percentage', item.Multi_Part_Question_Percentage);
    append('Deleted_Ind', item.Deleted_Ind);
    append('Display_Order', item.Display_Order);

        // Image metadata fields
    append('Course_Subject_Image_File_Object_Id', item.Course_Subject_Image_File_Object_Id);
    append('Course_Subject_Image_File_Name', item.Course_Subject_Image_File_Name);
    append('Course_Subject_Image_File_Name_In_Server', item.Course_Subject_Image_File_Name_In_Server);
    append('Course_Subject_Image_File_Source_Modified_Datetime', item.Course_Subject_Image_File_Source_Modified_Datetime);
    append('Course_Subject_Image_File_Type_Code', item.Course_Subject_Image_File_Type_Code);
    append('Course_Subject_Image_File_Location_Name', item.Course_Subject_Image_File_Location_Name);
    append('Course_Subject_Image_Height', item.Course_Subject_Image_Height);
    append('Course_Subject_Image_Width', item.Course_Subject_Image_Width);
    append('Course_Subject_Image_Deleted_Ind', item.Course_Subject_Image_File_Object_Id&&item?.imageFile ? 'Y':'N');
    append('Course_Subject_Image_Archive_Ind', item.Course_Subject_Image_Archive_Ind);
    append('Course_Subject_Image_File_Archive_Location_Name', item.Course_Subject_Image_File_Archive_Location_Name);


  });

  console.log("------ FormData Contents ------");
fd.forEach((value, key) => {
  console.log(key, value);
});
console.log("------ END ------");
  this.ExamService.InsertOrUpdateExamInstanceSubject(fd).subscribe(
    (res) => {
      this.insertresponse = res;
      this.ExamInstanceSubjectForm.get('Preview_Exam_Instance_Name')?.reset();

      if (this.insertresponse.status) {
        this.formSubmitted = false;
        if(!isDelete){
        this.toastr.success('Saved Successfully', 'Success', { timeOut: 500 });
        }
        this.CloseExaminstancesubject.emit(1);
        if(isClose){
            this.onCloseSubject.emit()
        }
        // clear tombstones only after success
        this.toDeleteRows = [];

        // reload fres  h
        this.ExamService.getExamInstanceSubject({
          LoggedInUserID: this.session.getUser(),
          CourseID: +this.courseId!,
         CourseSubjectID: null,
        }).subscribe(res => {
          if(isDelete){
            const drafts = this.ExamInstanceSubject.filter(r => !r.Course_Subject_ID);

          this.getExamInstanceSubjectResponse(res)
              this.ExamInstanceSubject = [
              ...this.ExamInstanceSubject,
              ...drafts
            ];
        }
          else{
            this.getExamInstanceSubjectResponse(res)
          }

        });
        this.getSubjectListForDropDown();
      } else {
        this.toastr.error(this.insertresponse.message);
      }
    },
    () => this.toastr.error('ERROR!', this.insertresponse?.message)
  );
}



  Cancel() {
    this.CloseExaminstancesubject.emit(1);
  }

  subjectwiseconceptflag: boolean;
  ClickSubjectWise(Subject_Id: any, Exam_Instance_Subject_ID: any) {
    console.log(Subject_Id, Exam_Instance_Subject_ID);

    this.subjectwiseconceptflag = !this.subjectwiseconceptflag;
    this.ExamService.ExamSubjectID = Subject_Id;
    this.ExamService.ExamInstanceSubjectID =
      Exam_Instance_Subject_ID?.Course_Subject_ID;
    this.ExamService.ExamInstanceID = Exam_Instance_Subject_ID?.Course_ID;
  }

  changeToCourseSubject(event: any) {
    this.courseId =
      this.ExamInstanceSubjectForm.value.Preview_Exam_Instance_Name;
    this.ngOnInit();
  }
}
